module.exports = "<div class=label>{{ $ctrl.startText }}</div> <div class=count>{{ $ctrl.endText }}</div> ";